"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _RunningRound = _interopRequireDefault(require("@rsuite/icon-font/lib/status/RunningRound"));

// Generated by script, don't edit it please.
var RunningRound = (0, _createSvgIcon["default"])({
  as: _RunningRound["default"],
  ariaLabel: 'running round',
  category: 'status',
  displayName: 'RunningRound'
});
var _default = RunningRound;
exports["default"] = _default;
module.exports = exports.default;